import { Field, ID, ObjectType } from 'type-graphql'
import { Column, Entity, Index, ManyToOne, PrimaryGeneratedColumn, RelationId, JoinColumn } from 'typeorm'

import {
  HistoryActionColumn,
  HistoryActionType,
  HistoryEntityInterface,
  HistoryOriginalIdColumn
} from '@operato/typeorm-history'
import { Role, User } from '@things-factory/auth-base'
import { config } from '@things-factory/env'
import { Domain, ScalarObject } from '@things-factory/shell'

import { Kpi, KpiStatus, KpiPeriodType } from './kpi'
import { KpiScores } from './kpi-grade.types'

const ORMCONFIG = config.get('ormconfig', {})
const DATABASE_TYPE = ORMCONFIG.type

@Entity()
@Index('ix_kpi_history_0', (kpiHistory: KpiHistory) => [kpiHistory.originalId, kpiHistory.version], { unique: true })
@Index('ix_kpi_history_1', (kpiHistory: KpiHistory) => [kpiHistory.domain, kpiHistory.originalId, kpiHistory.version], {
  unique: true
})
@ObjectType({ description: 'History Entity of Kpi' })
export class KpiHistory implements HistoryEntityInterface<Kpi> {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  readonly id: string

  @Column({ nullable: true, default: 1 })
  @Field({ nullable: true })
  version?: number = 1

  @ManyToOne(type => Domain)
  @Field({ nullable: true })
  domain?: Domain

  @RelationId((kpi: Kpi) => kpi.domain)
  domainId?: string

  @Column()
  @Field()
  name: string

  @Column({ nullable: true })
  @Field({ nullable: true })
  description?: string

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'Calculation formula for the KPI.' })
  formula?: string

  @Column({ nullable: false, default: false })
  @Field({ nullable: true, description: 'Whether this KPI is active (usable) or not.' })
  active?: boolean

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'Current state of the KPI (DRAFT, RELEASED, ARCHIVED).' })
  state?: KpiStatus

  @Field(type => String, { nullable: true, description: 'Thumbnail image or file path for this KPI.' })
  thumbnail?: string

  @Column({ type: 'simple-json', nullable: true })
  @Field(type => ScalarObject, {
    nullable: true,
    description: 'Grade configuration for this KPI version'
  })
  grades?: KpiScores

  @Column({ type: 'float', nullable: true, default: 1 })
  @Field({ nullable: true, description: 'Weight for aggregation in parent category.' })
  weight?: number

  @Column({ default: 'DAY' })
  @Field(type => KpiPeriodType, { nullable: true })
  periodType: KpiPeriodType

  @Column({ nullable: true })
  @Field({ nullable: true })
  createdAt?: Date

  @Column({ nullable: true })
  @Field({ nullable: true })
  updatedAt?: Date

  @Column({ nullable: true })
  @Field({ nullable: true })
  deletedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((kpi: Kpi) => kpi.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((kpi: Kpi) => kpi.updater)
  updaterId?: string

  @HistoryOriginalIdColumn()
  public originalId!: string

  @HistoryActionColumn({
    nullable: false,
    type:
      DATABASE_TYPE == 'postgres' || DATABASE_TYPE == 'mysql' || DATABASE_TYPE == 'mariadb'
        ? 'enum'
        : DATABASE_TYPE == 'oracle'
          ? 'varchar2'
          : DATABASE_TYPE == 'mssql'
            ? 'nvarchar'
            : 'varchar',
    enum:
      DATABASE_TYPE == 'postgres' || DATABASE_TYPE == 'mysql' || DATABASE_TYPE == 'mariadb'
        ? HistoryActionType
        : undefined,
    length: DATABASE_TYPE == 'postgres' || DATABASE_TYPE == 'mysql' || DATABASE_TYPE == 'mariadb' ? undefined : 32
  })
  public action!: HistoryActionType
}
